import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Invitee } from 'server/shared/models/invitee';
import { InviteeStatusEnum } from 'server/shared/models/jobInviteeStatusEnum';

@Component({
  selector: 'app-job-invitee-status-icon',
  templateUrl: './job-invitee-status-icon.component.html',
  styleUrls: ['./job-invitee-status-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobInviteeStatusIconComponent {
  @Input() invitee?: Invitee;

  constructor() {}

  readonly InviteeStatusEnum = InviteeStatusEnum;
}
